import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const SLOT_ID = 'staff-banner-slot';

/** An empty strip under the staff top bar where a page can show a full-width notice (Figma A03.2 "Admin override"). */
export function StaffBannerSlot() {
  return <div id={SLOT_ID} />;
}

/** Renders its children into the shell's banner strip. Renders nothing until the strip exists (the first paint). */
export function StaffBanner({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => setSlot(document.getElementById(SLOT_ID)), []);
  return slot ? createPortal(children, slot) : null;
}
